(function () {
  // Two thresholds instead of one: scrolling right around a single trigger point
  // flickers the 650ms solid/transparent transition back and forth. Entering solid
  // needs to pass 220px, but leaving solid only needs to fall back below 180px —
  // that 40px dead zone is the hysteresis band.
  var ENTER_THRESHOLD = 220;
  var EXIT_THRESHOLD = 180;
  var header = null;
  var ticking = false;
  var solid = false;

  function apply() {
    if (!header) return;
    var y = window.scrollY;
    if (!solid && y > ENTER_THRESHOLD) {
      solid = true;
    } else if (solid && y < EXIT_THRESHOLD) {
      solid = false;
    }
    header.classList.toggle('daoud-header-solid', solid);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  function bind() {
    header = document.getElementById('header-component');
    if (!header || !header.hasAttribute('transparent')) return;
    apply();
    document.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
